<div class="profile-picture">
    <img [src]="'https://firebasestorage.googleapis.com/v0/b/angular-pwa-cf61b.appspot.com/o/' + user.uid + '.svg?alt=media'" />
</div>
<span class="user-info">
    <strong>{{ user.displayname }}</strong>
    <span>{{ user.company }}</span>
</span>
